<h2 mat-dialog-title>{{ 'TermsOfService.TermsOfService' | translate }}</h2>
<mat-dialog-content>
    <p>{{ 'TermsOfService.TosDescription' | translate }}</p>
    <div>
        <a [href]="linkTos()" target="_blank" class="link mb-2">
            {{ 'TermsOfService.TermsOfService' | translate }}
        </a>
    </div>
    <div>
        <a [href]="linkPrivacyStatement()" target="_blank" class="link mb-4">
            {{ 'TermsOfService.PrivacyStatement' | translate }}
        </a>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-flat-button (click)="acceptTos()" [disabled]="isLoading()" color="primary" class="w-100">
        {{ 'TermsOfService.AcceptTos' | translate }}
    </button>
</mat-dialog-actions>
